import TaskManager from "../";

const routes = [
    { name: "TaskList", path: "/taskmanager", component: TaskManager.TaskManagerList },
    { name: "TaskView", path: "/taskmanager/view/:id", component: TaskManager.TaskManagerView },
    { name: "TaskEdit", path: "/taskmanager/edit/:id", component: TaskManager.TaskManagerEditPage },
];

export default routes;
